<template>
    <footer class="l-footer">
        <div class="l-footer__menu">
            <ul>
                <li><router-link :to="{ name: 'news.list'}">{{ $t('LABEL_NEWS') }}</router-link></li>
                <li><router-link :to="{ name: 'contact.us'}">{{ $t('LABEL_ENQUIRY') }}</router-link></li>
                <li><a :href="hubsynchAboutUsUrl">{{ $t('LABEL_ABOUT_US') }}</a></li>
            </ul>
            <ul>
                <li><router-link :to="{ name: 'user.terms'}">{{ $t('LABEL_MERCHANT_TERM_OF_USE') }}</router-link></li>
                <li><router-link id="link-privacy-policy-1" :to="{ name: 'privacy.policy' }">{{ $t('LABEL_PRIVACY_POLICY') }}</router-link></li>
                <li><router-link :to="{ name: 'personal.information'}">{{ $t('LABEL_HANDLING_OF_PERSONAL_DATA') }}</router-link></li>
                <!-- <li><a href="#">{{ $t('LABEL_SYSTEM_REQUIREMENTS') }}</a></li> -->
                <li><a :href="hubsynchCompanyUrl">{{ $t('LABEL_COMPANY_PROFILE') }}</a></li>
            </ul>
        </div>
        <address>&copy;&nbsp;hubsynch&nbsp;Inc.</address>
    </footer>
</template>

<script setup>
import { onBeforeMount, ref } from "vue";
const hubsynchAboutUsUrl = ref("");
const hubsynchCompanyUrl = ref("");
onBeforeMount(() => {
    hubsynchAboutUsUrl.value = process.env.VUE_APP_HUBSYNCH_ABOUT_US_URL;
    hubsynchCompanyUrl.value = process.env.VUE_APP_HUBSYNCH_COMPANY_URL;
});
</script>